        <!-- UserList 修改用户 -->
<template>
  <div>
    <!-- 表头 -->
    <div class="userList">
      <div class="userList_return" @click="returnClick()">
        <i class="el-icon-arrow-left fl"></i>
        <span class="fl">返回</span>
      </div>
      <h1>修改用户</h1>
      <div class="userList_time clearfix">
        <i class="el-icon-date fl"></i>
        <span class="fl">{{ dataTime }}</span>
        <span class="fl">{{ textTime }}</span>
      </div>
    </div>

    <!-- 数据列表 -->
    <div class="userList_content" v-show="false">
      <!-- 查询条件 -->
      <div class="hJ212Records_query">
        <div class="query_list clearfix fl" v-show="options.length">
          <span class="fl">归属机构：</span>
          <el-cascader
            class="fl"
            :clearable="true"
            v-model="value"
            :checkStrictly="true"
            :options="options"
            placeholder="系统管理机构"
            filterable
            :props="{ expandTrigger: 'hover', checkStrictly: true }"
            @change="handleChange"
          ></el-cascader>
        </div>

        <div class="query_list clearfix fl">
          <span class="fl">选择角色：</span>
          <el-select v-model="value" placeholder="请选择">
            <el-option
              v-for="item in lists"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>

        <el-button type="primary" icon="el-icon-search"> 查询 </el-button>
        <!-- <el-button type="success" icon="el-icon-upload2">导出</el-button> -->
      </div>

      <div class="deviceMonitor_title">
        <el-row>
          <el-col :xs="3" :sm="3" :md="3" :lg="3" :xl="3">
            <div class="">归属机构</div>
          </el-col>
          <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">
            <div class="">用户ID</div>
          </el-col>
          <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">
            <div class="">登录账号</div>
          </el-col>
          <el-col :xs="3" :sm="3" :md="3" :lg="3" :xl="3">
            <div class="">姓名</div>
          </el-col>
          <el-col :xs="3" :sm="3" :md="3" :lg="3" :xl="3">
            <div class="">角色</div>
          </el-col>
          <el-col :xs="3" :sm="3" :md="3" :lg="3" :xl="3">
            <div class="">登录时间</div>
          </el-col>
          <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1">
            <div class="">性别</div>
          </el-col>
          <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1">
            <div class="">状态</div>
          </el-col>
          <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
            <div class="">操作</div>
          </el-col>
        </el-row>
      </div>
      <div class="deviceMonitor_list" v-for="(item, index) in list" :key="index">
        <el-row>
          <el-col :xs="3" :sm="3" :md="3" :lg="3" :xl="3">
            <div class="deviceMonitor_tab">{{item.deptId == '100000000' ? '系统管理机构' : map[item.deptId]}}</div>
          </el-col>
          <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">
            <div class="deviceMonitor_tab">{{item.userId}}</div>
          </el-col>
          <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">
            <div class="deviceMonitor_tab">{{item.shortId}}</div>
          </el-col>
          <el-col :xs="3" :sm="3" :md="3" :lg="3" :xl="3">
            <div class="deviceMonitor_tab">{{item.userName}}</div>
          </el-col>
          <el-col :xs="3" :sm="3" :md="3" :lg="3" :xl="3">
            <div class="deviceMonitor_tab">{{item.roles}}</div>
          </el-col>
          <el-col :xs="3" :sm="3" :md="3" :lg="3" :xl="3">
            <div class="deviceMonitor_tab">{{item.lastTime}}</div>
          </el-col>
          <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1">
            <div class="deviceMonitor_tab">{{item.gender == 'M' ? '男' : '女'}}</div>
          </el-col>
          <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1">
            <div class="deviceMonitor_tab">{{item.status == '0' ? '停用' : '正常'}}</div>
          </el-col>
          <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
            <div class="deviceMonitor_tab">
              <span>明细</span>
              &nbsp;|&nbsp;
              <span>修改</span>
              &nbsp;|&nbsp;
              <span>删除</span>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- 内容 -->
    <iframe
      v-show="true"
      class="kanbanMng_content"
      :src="apiUrls + '?txcode=UserList'"
      frameborder="0"
    >
    </iframe>
  </div>
</template>

<script>
// 引入日期时间
import { dateTime } from "../../assets/js/data";
export default {
  data() {
    return {
      // 定时器
      timer: "",
      // 日期时间
      dataTime: "",
      // 星期
      textTime: "",

      // 机构树
      options: [],
      // 当前选择机构
      value: [],
      // 当前机构ID
      deptId: "",

       lists: [{
          value: '选项1',
          label: '协议卡管理'
        }, {
          value: '选项2',
          label: 'HJ212管理'
        }, {
          value: '选项3',
          label: '协议卡查询'
        }, {
          value: '选项4',
          label: 'HJ212查询'
        }],
        value: '',


        list:[],

        map:{},
      apiUrls:''
    };
  },
  created() {
    this.apiUrls = this.apiUrl;
    // 获取机构树
    this.options = JSON.parse(localStorage.getItem("structure"));

    //   日期时间赋值
    this.dataTime = dateTime();
    //   清除定时器
    window.clearInterval(this.timer);
    let _this = this;
    // 定时更新时间
    this.timer = setInterval(() => {
      _this.dataTime = dateTime();
    }, 1000);

    let date = new Date();
    let num = date.getDay();
    if (num == 0) {
      this.textTime = "星期天";
    }
    if (num == 1) {
      this.textTime = "星期一";
    }
    if (num == 2) {
      this.textTime = "星期二";
    }
    if (num == 3) {
      this.textTime = "星期三";
    }
    if (num == 4) {
      this.textTime = "星期四";
    }
    if (num == 5) {
      this.textTime = "星期五";
    }
    if (num == 6) {
      this.textTime = "星期六";
    }

    this.UserList();

    this.fn();
  },
  methods: {
    fn(){
         // 获取loginToken
      let loginToken = localStorage.getItem("loginToken");
      this.$axios({
        method: "post",
        url: this.api,
        data: {
          txcode: "PubAction", //交易码
          option:'DeptTree',
          deptId: "", //归属机构ID
          loginToken,
        },
      })
        .then((res) => {
          if (res.data._STATUS == "0") {
            this.map = res.data.map;
          } else {
            // 登录超时，调用全局方法
            this.loginTimeout();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 用户管理
    UserList() {
      // 获取loginToken
      let loginToken = localStorage.getItem("loginToken");
      this.$axios({
        method: "post",
        url: this.api,
        data: {
          txcode: "UserList", //交易码
          deptId: "", //归属机构ID
          findScope: 1, //查找范围，0本级机构用户，1包含下属机构。
          findKey: "", //查询标识
          findWord: "", //匹配关键字
          roleId: "", //用户角色，0系统管理员，1编辑员，2查询用户，3软件配置员。
          loginToken,
        },
      })
        .then((res) => {
          if (res.data._STATUS == "0") {
            console.log(res,this.options);
            this.list = res.data.list;
          } else {
            // 登录超时，调用全局方法
            this.loginTimeout();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 现在所属机构
    handleChange(value) {
      this.deviceId = "";
      let val = JSON.parse(JSON.stringify(value));
      if (val.length >= 1) {
        this.deptId = val[val.length - 1];
      } else {
        this.deptId = "";
      }
    },
    // 返回上一级
    returnClick() {
      this.$router.go(-1);
    },
  },
};
</script>


<style lang="less" scoped>
// 表头
.userList {
  width: 100%;
  height: 50px;
  background-color: #304156;
  position: relative;
  h1 {
    min-width: 300px;
    margin: 0 auto;
    height: 50px;
    line-height: 50px;
    font-size: 26px;
    letter-spacing: 6px;
    font-weight: bold;
    text-align: center;
    color: #fff;
  }
  .userList_return {
    position: absolute;
    top: 0;
    left: 0;
    height: 50px;
    overflow: hidden;
    line-height: 50px;
    color: #fff;
    &:hover {
      cursor: pointer;
      text-shadow: #000 0 0 2px;
    }
    i {
      font-weight: bold;
      margin-left: 20px;
      font-size: 20px;
      line-height: 52px;
    }
    span {
      line-height: 50px;
      font-size: 20px;
    }
  }
  .userList_time {
    position: absolute;
    top: 0;
    right: 0;
    height: 50px;
    padding: 0 20px;
    color: #fff;
    i {
      font-size: 32px;
      line-height: 50px;
    }
    span {
      margin: 0 20px;
      font-size: 28px;
      line-height: 50px;
    }
  }
}

.userList_content {
  width: calc(100% - 40px);
  height: calc(100% - 80px);
  position: fixed;
  top: 55px;
  left: 20px;
  overflow-y: auto;
  padding-bottom: 50px;
  box-sizing: border-box;
  // 查询条件
  .hJ212Records_query {
    width: 100%;
    padding: 15px 20px;
    box-sizing: border-box;
    .query_list {
      height: 46px;
      line-height: 40px;
      margin-right: 20px;
    }
  }
  .deviceMonitor_title {
    width: 100%;
    text-align: center;
    color: #fff;
    height: 40px;
    line-height: 40px;
    background-color: #545c64;
  }
  .deviceMonitor_list {
    width: 100%;
    text-align: center;
    &:nth-child(2n-1) {
      background-color: #f0faff;
    }
    &:hover {
      cursor: pointer;
      background-color: rgb(253, 246, 238);
    }
    .deviceMonitor_tab {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #333;
      padding: 2px 10px;
      box-sizing: border-box;
      min-height: 40px;
    }
  }
}

// 内容
.kanbanMng_content {
  width: calc(100% - 40px);
  height: calc(100% - 80px);
  position: fixed;
  top: 65px;
  left: 20px;
}
</style>